/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCompetitiveTierResponse
 */
export interface GetCompetitiveTierResponse {
    /**
     * Authenticated user's DevourPlay Competitive Tier. Null when no tier has been computed yet (rare cold-start path).
     * @type {string}
     * @memberof GetCompetitiveTierResponse
     */
    tier: GetCompetitiveTierResponseTierEnum | null;
}


/**
 * @export
 */
export const GetCompetitiveTierResponseTierEnum = {
    BRONZE: 'BRONZE',
    SILVER: 'SILVER',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM',
    DIAMOND: 'DIAMOND'
} as const;
export type GetCompetitiveTierResponseTierEnum = typeof GetCompetitiveTierResponseTierEnum[keyof typeof GetCompetitiveTierResponseTierEnum];


/**
 * Check if a given object implements the GetCompetitiveTierResponse interface.
 */
export function instanceOfGetCompetitiveTierResponse(value: object): value is GetCompetitiveTierResponse {
    if (!('tier' in value) || value['tier'] === undefined) return false;
    return true;
}

export function GetCompetitiveTierResponseFromJSON(json: any): GetCompetitiveTierResponse {
    return GetCompetitiveTierResponseFromJSONTyped(json, false);
}

export function GetCompetitiveTierResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompetitiveTierResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tier': json['tier'],
    };
}

export function GetCompetitiveTierResponseToJSON(json: any): GetCompetitiveTierResponse {
    return GetCompetitiveTierResponseToJSONTyped(json, false);
}

export function GetCompetitiveTierResponseToJSONTyped(value?: GetCompetitiveTierResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tier': value['tier'],
    };
}

